<template>
    <div id="app" class="page-container">
        <md-app md-waterfall md-mode="fixed">
            <md-app-toolbar class="md-primary">
                <span class="md-title">
                    <a href="/"><img src="favicon.svg" style="width: 36px; height: 36px; margin-right: 24px" /></a>
                    ASS/SSA to SRT online subtitles converter
                </span>
                <md-button class="md-title md-icon-button md-dense md-primary" v-on:click="displayHelp=true">
                    <md-icon>help_outline</md-icon>
                </md-button>
                <span class="md-subheading" style="flex: 1; text-align: right;">© Hightlander 2020-2021</span>
            </md-app-toolbar>
            <md-app-content>
                <div class="md-layout md-alignment-center">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <md-card>
                            <md-card-header>
                                <div class="md-title">Select files to process</div>
                            </md-card-header>
                            <md-card-content>
                                <div class="file-drop default" @dragover="dragover" @dragleave="dragleave" @drop="drop" id="file-drop" @click="$refs.subtitleFileInput.click()">
                                    <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
                                           @change="onChange" ref="subtitleFileInput" accept=".ass,.ssa" />

                                    <label for="assetsFieldHandle" class="no-pointer-events"
                                           style="display: block;">
                                            Drop .ass\.ssa files here or click here
                                    </label>
                                </div>
                                <div class="md-caption">Your files will <b>not</b> be uploaded. It works directly in your browser.</div>
                            </md-card-content>
                            <md-snackbar :md-duration="5000" :md-active.sync="showNotification" md-persistent>
                                <span>Preprocessing ended</span>
                            </md-snackbar>
                        </md-card>
                    </div>
                </div>
                <div v-if="SrtSubtitles.length > 0" class="md-layout md-alignment-center" style="padding-top:46px">
                    <div class="md-layout-item md-size-100 md-small-size-100">
                        <md-table v-model="SrtSubtitles" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                            <md-table-toolbar>
                                <h1 class="md-title">Processed files</h1>
                                <md-button class="md-dense" v-on:click="displayHelp=true">
                                    How to use
                                </md-button>
                            </md-table-toolbar>
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="Filename" md-sort-by="filename">{{item.filename}}</md-table-cell>
                                <md-table-cell md-label="Styles">
                                    <div v-if="optionsArrayValid(item.styles)">
                                        <md-field>
                                            <md-select v-model="item.selectedStyles" name="styles" id="styles" multiple>
                                                <md-option v-for="itemStyle in item.styles" :value="itemStyle" :key="itemStyle">{{itemStyle}}</md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                    <div v-else class="opacity-60">
                                        Not available
                                    </div>
                                </md-table-cell>
                                <md-table-cell md-label="Roles">
                                    <div v-if="optionsArrayValid(item.names)">
                                        <md-field>
                                            <md-select v-model="item.selectedNames" name="names" id="names" multiple>
                                                <md-option v-for="itemName in item.names" :value="itemName" :key="itemName">{{itemName}}</md-option>
                                            </md-select>
                                        </md-field>
                                    </div>
                                    <div v-else class="opacity-60">
                                        Not available
                                    </div>
                                </md-table-cell>
                                <md-table-cell md-label="Download">
                                    <md-button v-if="item.success==true" class="md-icon-button" v-on:click="downloadSrt(item)">
                                        <md-icon>cloud_download</md-icon>
                                    </md-button>
                                    <div v-if="item.success==false" style="margin: 0px 14px">
                                        <md-icon class="md-accent">error_outline</md-icon>
                                        <md-tooltip md-direction="top">{{item.error}}</md-tooltip>
                                    </div>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </div>
                </div>
                <!--<div v-if="selectedSrtFile != null && selectedSrtFile.success == true" class="md-layout md-alignment-center" style="padding-top:46px">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <md-card>
                            <md-card-header>
                                <h1 class="md-title">{{selectedSrtFile.filename}}</h1>
                            </md-card-header>
                            <md-card-content style="white-space: pre-line">
                                {{selectedSrtFile.data}}
                            </md-card-content>
                        </md-card>
                    </div>
                </div>-->
            </md-app-content>
        </md-app>

        <help-dialog v-bind:mdActive.sync="displayHelp" />
    </div>

</template>

<script>
    import 'vue-material/dist/vue-material.min.css'
    import 'vue-material/dist/theme/default.css'
    import Vue from 'vue'
    import { MdButton, MdContent, MdApp, MdToolbar, MdField, MdCard, MdLayout, MdTable, MdRipple, MdSnackbar, MdBottomBar, MdTooltip, MdMenu, MdList, MdCheckbox } from 'vue-material/dist/components'
    import VueYandexMetrika from 'vue-yandex-metrika'

    Vue.use(MdButton)
    Vue.use(MdContent)
    Vue.use(MdApp)
    Vue.use(MdToolbar)
    Vue.use(MdField)
    Vue.use(MdCard)
    Vue.use(MdLayout)
    Vue.use(MdTable)
    Vue.use(MdRipple)
    Vue.use(MdSnackbar)
    Vue.use(MdBottomBar)
    Vue.use(MdTooltip)
    Vue.use(MdMenu)
    Vue.use(MdList)
    Vue.use(MdCheckbox)

    Vue.use(VueYandexMetrika, {
        id: 64329586,
        env: process.env.NODE_ENV,
        //env: 'production',
        options: {
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true
        }
        // other options
    })



    export default {
        name: 'app',
        mode: 'production',
        components: {
            HelpDialog: () => import('./components/HelpDialog.vue'),
        },
        data: function () {
            return {
                files: [],
                SrtSubtitles: [],
                showNotification: false,
                filesCount: 0,
                filesProcessed: 0,
                displayHelp: false,
                selectedSrtFile: null
            }
        },
        activated() {
            this.$metrika.hit("/");
        },
        methods: {
            process: function () {
                if (this.files.length == 0) {
                    return;
                }

                this.filesCount = this.files.length;
                this.filesProcessed = 0;

                for (var i = 0; i < this.files.length; i++) {
                    const file = this.files[i];
                    const filename = file.name.substring(0, file.name.length - 4) + ".srt";

                    (new Blob([file])).text().then(data => {
                        this.processFile(file.name, filename, data);
                        this.filesProcessed++;

                        if (this.filesProcessed >= this.filesCount) {
                            this.showNotification = true;
                        }
                    });
                }
            },
            processFile: function (originalFilename, filename, data) {
                var srtData = "";
                var success = false;
                var error = "";
                var styles = [];
                var names = [];

                const correctFormatRegexp = /[^\n\r]+[.]{1}(ass|ssa)/g;
                if (correctFormatRegexp.test(originalFilename)) {
                    var counter = 1;
                    var EventsStarted = false;
                    var lines = data.split('\n');
                    for (var i = 0; i < lines.length; i++) {
                        var Line = lines[i];

                        if (EventsStarted) {
                            if (Line.startsWith("Format:")) {
                                continue;
                            }

                            var cells = Line.split(',');
                            if (cells.length >= 10) {
                                var start = cells[1].replace('.', ',') + "0";
                                var end = cells[2].replace('.', ',') + "0";
                                var style = cells[3];
                                var name = cells[4];

                                if (style == '') {
                                    style = "Unknown";
                                }

                                if (name == '') {
                                    name = "Unknown";
                                }

                                if (!styles.includes(style)) {
                                    styles.push(style);
                                }

                                if (!names.includes(name)) {
                                    names.push(name);
                                }

                                var SubtitlesTextRegexp = /(?:[^\n\r,]*?,){9}([^\n\r]*)/g;
                                var subs = SubtitlesTextRegexp.exec(Line)[1];
                                subs = subs.replace(/({[^\n\r]*?})/g, '');
                                subs = subs.replace(/([\\][N])+/g, '\n');


                                srtData = srtData + counter + "\n" + start + " --> " + end + "\n" + subs + "\n\n";
                                counter += 1;
                            }
                        }
                        else if (Line.startsWith("[Events]")) {
                            EventsStarted = true;
                        }
                    }

                    if (srtData == "") {
                        success = false;
                        error = "Wrong format";
                    }
                    else {
                        success = true;
                    }
                }
                else {
                    error = "Wrong extension. Should be .ASS or .SSA";
                }
                this.SrtSubtitles.push({ filename: filename, data: srtData, original: data, success: success, error: error, styles: styles, selectedStyles: styles, names: names, selectedNames: names });
            },
            downloadSrt: function (item) {
                this.$metrika.reachGoal('download-pressed');
                var srtData = "";

                var counter = 1;
                var EventsStarted = false;
                var lines = item.original.split('\n');
                for (var i = 0; i < lines.length; i++) {
                    var Line = lines[i];

                    if (EventsStarted) {
                        if (Line.startsWith("Format:")) {
                            continue;
                        }

                        var cells = Line.split(',');
                        if (cells.length >= 10) {
                            var start = cells[1].replace('.', ',') + "0";
                            var end = cells[2].replace('.', ',') + "0";
                            var style = cells[3];
                            var name = cells[4];

                            if (this.optionsArrayValid(item.styles) && (!item.selectedStyles.includes(style) && (style != '' || !item.selectedStyles.includes("Unknown")))) {
                                continue;
                            }

                            if (this.optionsArrayValid(item.names) && (!item.selectedNames.includes(name) && (name != '' || !item.selectedNames.includes("Unknown")))) {
                                continue;
                            }

                            var SubtitlesTextRegexp = /(?:[^\n\r,]*?,){9}([^\n\r]*)/g;
                            var subs = SubtitlesTextRegexp.exec(Line)[1];
                            subs = subs.replace(/({[^\n\r]*?})/g, '');
                            subs = subs.replace(/([\\][N])+/g, '\n');


                            srtData = srtData + counter + "\n" + start + " --> " + end + "\n" + subs + "\n\n";
                            counter += 1;
                        }
                    }
                    else if (Line.startsWith("[Events]")) {
                        EventsStarted = true;
                    }
                }

                if (srtData != "") {
                    this.save(item.filename, srtData);
                }
            },
            save: function (filename, data) {
                var blob = new Blob([data], { type: 'text/csv' });
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveBlob(blob, filename);
                }
                else {
                    var elem = window.document.createElement('a');
                    elem.href = window.URL.createObjectURL(blob);
                    elem.download = filename;
                    document.body.appendChild(elem);
                    elem.click();
                    document.body.removeChild(elem);
                }
            },
            onSrtSelect: function (item) {
                this.selectedSrtFile = item;
            },
            optionsArrayValid: function (array) {
                return array.length > 1;
            },
            onChange() {
                this.files = [...this.$refs.subtitleFileInput.files];
                this.process();
            },
            dragover(event) {
                event.preventDefault();
                event.dataTransfer.effectAllowed = "link";
                // Add some visual fluff to show the user can drop its files
                if (!event.currentTarget.classList.contains('hovered')) {
                    event.currentTarget.classList.remove('default');
                    event.currentTarget.classList.add('hovered');
                }
            },
            dragleave(event) {
                // Clean up
                event.currentTarget.classList.add('default');
                event.currentTarget.classList.remove('hovered');
            },
            drop(event) {
                event.preventDefault();
                this.$refs.subtitleFileInput.files = event.dataTransfer.files;
                this.onChange(); // Trigger the onChange event manually
                // Clean up
                event.currentTarget.classList.add('default');
                event.currentTarget.classList.remove('hovered');
            }
        }
    };
</script>

<style>
    .file-drop {
        border: 1px solid #e2e8f0;
        padding: 3rem;
        text-align: center;
        cursor: pointer;
    }

        .file-drop input {
            opacity: 0;
            width: 1px;
            height: 1px;
            position: absolute;
            overflow: hidden;
        }

        .file-drop.default {
            background-color: #f7fafc;
        }

        .file-drop.hovered {
            background-color: #99ccae;
        }

    .no-pointer-events {
        pointer-events: none;
    }

    .opacity-60{
        opacity: 0.6;
    }
</style>

